import React, {useState, useEffect} from 'react';

import DatePicker from "react-datepicker";
import {
    formatDateToAmericanFormat,
    UserPermission
} from "../../../utils/utils";
import Config from "../../../core/config";
import {useRecoilState} from "recoil";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import 'react-datepicker/dist/react-datepicker.css';
import {makeRequest} from "../../../utils/httpRequest";
import Loading from "../../../core/Loading";
import {loadingAtom} from "../../../atoms";
import {usePermission} from "../../../core/PermissionContext";

const apiUrl = Config.apiUrl;
const ReportAutomotiveServiceByItem = (props) => {
    const { hasUserPermission, loadingPermissions } = usePermission();

    const currentDate = new Date();
    // Calculate current week's start (Saturday) and end (Friday)
    const currentDay = currentDate.getDay(); // 0 = Sunday, 1 = Monday, etc.
    const daysFromSaturday = currentDay === 6 ? 0 : currentDay === 0 ? 1 : currentDay + 1; // Adjust for Saturday start
    const firstDayOfWeek = new Date(currentDate);
    firstDayOfWeek.setDate(currentDate.getDate() - daysFromSaturday);
    firstDayOfWeek.setHours(0, 0, 0, 0);
    
    const lastDayOfWeek = new Date(firstDayOfWeek);
    lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
    lastDayOfWeek.setHours(23, 59, 59, 999);
    
    const [items, setItems] = useState([]);
    const [startDate, setStartDate] = useState(firstDayOfWeek);
    const [endDate, setEndDate] = useState(lastDayOfWeek);
    const [totalValue, setTotalValue] = useState(0);
    const navigate = useNavigate();
    const [selectedItemType, setSelectedItemType] = useState('ALL');
    const [selectedStatus, setSelectedStatus] = useState('TODOS');
    const [loading, setLoading] = useRecoilState(loadingAtom);

    async function makeQuery() {
        try {
            const newStartDate = startDate ? startDate : new Date(1900, 0, 1);
            const newEndDate = endDate ? endDate : new Date(2100, 0, 1);
            const url = `${apiUrl}/api/automotiveservices/report/automotive_service_by_item?startDate=${formatDateToAmericanFormat(newStartDate)}&endDate=${formatDateToAmericanFormat(newEndDate)}&itemType=${selectedItemType}&status=${selectedStatus}`;
            setLoading(true);
            const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
            setItems(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        makeQuery();
    }, []); // Empty dependency array ensures that useEffect runs only once, similar to componentDidMount

    useEffect(() => {
        setTotalValue(items.reduce((acc, obj) => acc + obj.totalValue, 0));
    }, [items]);

    const handleQuery = async (e) => {
        await makeQuery();
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
    };

    const [sortConfig, setSortConfig] = useState({key: 'totalValue', direction: 'descending'});

    const [sortedItems, setSortedItems] = useState([]);

    useEffect(() => {
        setSortedItems([...items].sort((a, b) => {
            const aValue = sortConfig.key.includes('.') ? a[sortConfig.key.split('.')[0]][sortConfig.key.split('.')[1]] : a[sortConfig.key];
            const bValue = sortConfig.key.includes('.') ? b[sortConfig.key.split('.')[0]][sortConfig.key.split('.')[1]] : b[sortConfig.key];

            if (aValue < bValue) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        }));
    }, [items, sortConfig]);

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({key, direction});
    };

    const getSortIcon = (key) => {
        if (sortConfig.key === key) {
            return sortConfig.direction === 'ascending' ? '▲' : '▼';
        }
        return '';
    };

    if(loadingPermissions) {
        return <Loading/>
    }

    if(!hasUserPermission(UserPermission.REPORT_AUTOMOTIVE_SERVICE_BY_ITEM)) {
        navigate('/unauthorizedaccess');
    }

    return (
        <>
            <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                <div className="header-label">Relatório de Serviços Automotivos por Item</div>
            </div>
            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', width: '100%'}}>

                <div style={{marginTop: '5px', alignItems: 'center', display: "flex"}}>
                    <div style={{flexDirection: "column", alignItems: 'center'}}>

                        Data de Entrega:
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <DatePicker
                                className="datepicker"
                                selected={startDate}
                                onChange={handleStartDateChange}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                autoComplete="off"
                            />

                            até
                            <DatePicker
                                className="datepicker"
                                selected={endDate}
                                onChange={handleEndDateChange}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div style={{flexDirection: "column", alignItems: 'center'}}>

                        Tipo de Item
                        <div style={{display: 'flex', alignItems: 'center'}}>

                            <select value={selectedItemType}
                                    onChange={(e) => setSelectedItemType(e.target.value)}>
                                <option value="ALL">Todos</option>
                                <option value="PRODUCT">Produto</option>
                                <option value="SERVICE">Serviço</option>
                            </select>
                        </div>

                    </div>

                    <div style={{flexDirection: "column", alignItems: 'center'}}>

                        Status
                        <div style={{display: 'flex', alignItems: 'center'}}>

                            <select value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}>
                                <option value="TODOS">Todos</option>
                                <option value="OPENING">Abertura</option>
                                <option value="PRODUCTION">Produção</option>
                                <option value="CONCLUDED">Concluído</option>
                                <option value="CANCELED">Cancelado</option>
                            </select>
                            <button onClick={handleQuery}>Consultar</button>
                        </div>

                    </div>


                </div>

            </div>

            <table style={{width: '100%', maxHeight: '100%'}}>

                <tr>
                    <th style={{cursor: "pointer", minWidth: "80px"}} onClick={() => handleSort('serviceCode')}>
                        {getSortIcon('serviceCode')} Código
                    </th>
                    <th style={{cursor: "pointer", minWidth: "150px"}} onClick={() => handleSort('customerName')}>
                        {getSortIcon('customerName')} Cliente
                    </th>
                    <th style={{cursor: "pointer", minWidth: "120px"}} onClick={() => handleSort('carName')}>
                        {getSortIcon('carName')} Carro
                    </th>
                    <th style={{cursor: "pointer", minWidth: "100px"}} onClick={() => handleSort('deliveryDate')}>
                        {getSortIcon('deliveryDate')} Data Entrega
                    </th>
                    <th style={{cursor: "pointer", minWidth: "100px"}} onClick={() => handleSort('status')}>
                        {getSortIcon('status')} Status
                    </th>
                    <th style={{cursor: "pointer", minWidth: "200px"}} onClick={() => handleSort('itemName')}>
                        {getSortIcon('itemName')} Item
                    </th>
                    <th style={{cursor: "pointer", minWidth: "100px"}} onClick={() => handleSort('itemType')}>
                        {getSortIcon('itemType')} Tipo
                    </th>
                    <th style={{cursor: "pointer", minWidth: "100px", textAlign: 'right'}} onClick={() => handleSort('totalQuantity')}>
                        {getSortIcon('totalQuantity')} Quantidade
                    </th>
                    <th style={{cursor: "pointer", minWidth: "100px", textAlign: 'right'}} onClick={() => handleSort('totalValue')}>
                        {getSortIcon('totalValue')} Valor Total
                    </th>
                </tr>
                <tbody style={{overflowY: 'auto'}}>
                {sortedItems.map((item, index) => (
                    <tr key={index}>
                        <td>
                            <div>{item.serviceCode}</div>
                        </td>
                        <td>
                            <div>{item.customerName}</div>
                        </td>
                        <td>
                            <div>{item.carName}</div>
                        </td>
                        <td>
                            <div>{item.deliveryDate}</div>
                        </td>
                        <td>
                            <div>{item.statusLabel}</div>
                        </td>
                        <td>
                            <div>{item.itemName}</div>
                        </td>
                        <td>
                            <div>{item.itemType === 'PRODUCT' ? 'Produto' : 'Serviço'}</div>
                        </td>
                        <td>
                            <div style={{textAlign: 'right'}}>{item.totalQuantity}</div>
                        </td>
                        <td>
                            <div style={{textAlign: 'right'}}>{item.totalValue.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}</div>
                        </td>
                    </tr>
                ))}
                </tbody>
                {items.length === 0 && (<tfoot>{loading ? 'Carregando...' : `Nenhum item encontrado.`}</tfoot>)}
            </table>
            <div style={{marginTop: '5px', alignItems: 'center', display:'flex', gap:'10px'}}>
                <div className="total-label">Quantidade de Itens: {items.length}</div>
                <div className="total-label">Valor Total: R$ {totalValue.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}</div>
            </div>
        </>
    );
};

export default ReportAutomotiveServiceByItem; 